import { Injectable } from '@angular/core';
import { LogLevel } from 'common/utility/logger/logLevel';
import { Observable } from 'rxjs';
import { Api } from 'services/http/api-endpoints';
import { HttpService } from 'services/http/http.service';
import { Endpoint } from 'services/http/interface/endpoint';
import { Route } from 'services/http/routes';
import { Create } from './request/create';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  public create(message: string, logLevel: number): Observable<any> {
    const body: Create = new Create(message)
    const action: string = Route.Logging.Send;
    const endpoint: Endpoint = Api.getEndpoint(Api.logging, action);
    const level: string = LogLevel.getLevel(logLevel)
    return this.httpService.request(Api.logging, action, Api.createParameters(endpoint.route, [level]), body)
  }


  constructor(
    private httpService: HttpService,
  ) { }
}
